import React from "react"
import PropTypes from "prop-types"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import { sanitizer } from "@commonUtils"
import css from "./Tag.scss"

function Tag({ label, color, backgroundColor, borderColor, image, className, textClassName }) {
    return (
        // flex is added to remove the unneeded space above the tag
        <div className={`flex ${className}`}>
            <span
                className={`flex alignCenter xSmallMedium padding-0-8 ${css.tag}`}
                style={{
                    color: color,
                    backgroundColor: backgroundColor,
                    // The tag should always have the same height whether there's border or
                    // not. That's why we are setting up inset border by using box shadow to
                    // work same for both the cases - with border, without border.
                    WebkitBoxShadow: `inset 0px 0px 0px 1px ${borderColor ? borderColor : "transparent"}`,
                    MozBoxShadow: `inset 0px 0px 0px 1px ${borderColor ? borderColor : "transparent"}`,
                    boxShadow: `inset 0px 0px 0px 1px ${borderColor ? borderColor : "transparent"}`,
                }}
            >
                {image?.url && (
                    <ImageLoader
                        src={image.url}
                        alt={image?.alt}
                        height={image?.height || "14px"}
                        width={image?.width || "14px"}
                    />
                )}
                <span
                    className={`${image?.url ? css.marginLeft4 : ""} ${textClassName}`}
                    dangerouslySetInnerHTML={{ __html: sanitizer(label) }}
                />
            </span>
        </div>
    )
}

Tag.propTypes = {
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    className: PropTypes.string,
    textClassName: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        height: PropTypes.string,
        width: PropTypes.string,
    }),
}

Tag.defaultProps = {
    color: "#3b3b3b",
    className: "",
    textClassName: "",
    image: {},
}

export default Tag
